// T-149 (v1.8.55, Session 43): Kundensuche im Buchungsdialog der Verwaltung (CustomerSelector). Bisher wurden nur die ersten 100
// Kunden (nach Umsatz) geladen und im Browser gefiltert; ab mehr als 100 Kunden galt ein vorhandener Kunde als nicht gefunden
// (Folge doppelte Anlage bzw. Ablehnung der doppelten E-Mail). Neu: Suchbegriff ab 2 Zeichen auch auf dem Server, Hinweis, wenn
// nicht alle Kunden geladen sind. Reine Funktionen, getestet in kundensuche.test.ts.

/** Anzahl der Kunden je Abruf (Liste ohne Suchbegriff bzw. Treffer einer Suche). */
export const KUNDEN_SEITENGROESSE = 200;

/** Suchbegriff für den Server: getrimmt, ab 2 Zeichen, sonst null (dann ungefilterte Liste). */
export function serverSuchbegriff(eingabe: string | null | undefined): string | null {
  const t = (eingabe ?? '').trim();
  return t.length >= 2 ? t : null;
}

/** Gesamtzahl aus der Antwort von GET api/admin/customers (pagination.totalCount), mindestens die geladene Anzahl. */
export function gesamtzahlAusAntwort(antwort: any, geladen: number): number {
  const p = antwort?.pagination ?? antwort?.Pagination ?? antwort?.data?.pagination ?? antwort?.data?.Pagination;
  const n = p?.totalCount ?? p?.TotalCount ?? antwort?.total;
  return typeof n === 'number' && n >= geladen ? n : geladen;
}

/** Hinweis unter der Suche, wenn nicht alle Kunden bzw. Treffer geladen sind; sonst null. */
export function kundenlisteHinweis(geladen: number, gesamt: number, suchbegriff: string | null): string | null {
  if (gesamt <= geladen) return null;
  return suchbegriff
    ? `${geladen} von ${gesamt} Treffern angezeigt. Bitte den Suchbegriff genauer fassen.`
    : `${geladen} von ${gesamt} Kunden angezeigt. Für alle Kunden bitte Name, E-Mail, Telefon oder Firma eingeben.`;
}
